import React from "react";

class NavbarToggle extends React.Component {
    render() {
        return (
            <nav style={{ borderRight: "1px solid #e1e5eb" }} className={"p-3"}>
                <div
                    style={{ width: "60px" }}
                    className="nav-link nav-link-icon toggle-sidebar d-sm-inline d-md-inline d-lg-none text-center"
                >
                    <i className="material-icons" style={{ color: "#52816d" }}>
                        &#xE5D2;
                    </i>
                </div>
            </nav>
        );
    }
}

export default NavbarToggle;
